var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[!_vm.isSidebarToggle ? 'toggalclass' : '']},[_c('loader',{attrs:{"is-visible":_vm.$root.loading}}),(
      _vm.$route.name !== 'homeNew' &&
      _vm.$route.name !== 'createaccount' &&
      _vm.$route.name !== 'activate' &&
      _vm.$route.name !== 'HomeIndia' &&
      _vm.$route.name !== 'createaccountIndia' &&
      _vm.$route.name !== 'activateIndia' &&
      _vm.$route.name !== 'createaccountNew2' &&
      _vm.$route.name !== 'activateNew2'
    )?[_c('div',{staticClass:"mainHeaderWrap"},[_c('HeaderNew',{on:{"toggleSidebar":_vm.toggleSidebar}})],1),_c('div',{},[_c('div',{},[_c('Sidenav',{attrs:{"isSidebarToggle":_vm.isSidebarToggle}})],1),_c('div',{staticClass:"mainContainerWrap"},[_c('router-view')],1)])]:[_c('router-view')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }